import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function ModernCardHeaderLable(): JSX.Element {
	return (
		<Box
			component="section"
			sx={{
				display: 'flex',
				alignItems: 'flex-end',
				width: '100%',
				height: '40px',
			}}
		>
			<Box
				component="div"
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '80px',
					height: '25px',
					background: 'var(--csmd-cl-primary-main)',
					borderTopRightRadius: '25px',
					borderBottomRightRadius: '25px',
				}}
			>
				<Typography sx={{ color: 'var(--csmd-cl-text-primary-footer)', fontSize: '.8rem' }}>
					Best Seller
				</Typography>
			</Box>
		</Box>
	);
}

export default ModernCardHeaderLable;
